import { useFeatureFlags } from 'utils/features';

export const usePtoUnpaidHours = () => useFeatureFlags('PTO_UNPAID_HOURS');
